import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    // title: {
    //   display: true,
    //   text: "Chart.js Bar Chart",
    // },
  },
};

// const labels = ["January", "February", "March", "April", "May", "June", "July"];
const labels = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function SalesPurchaseStates({ sales, purchases }) {
  const monthlyTotalSales = Array(12).fill(0);
  const monthlyTotalPurchases = Array(12).fill(0);

  sales.forEach((sale) => {
    const date = new Date(sale.createdAt);
    const year = date.getFullYear();
    const month = date.getMonth();

    if (year === 2023) {
      monthlyTotalSales[month] += sale.total_sale_amount;
    }
  });

  purchases.forEach((purchase) => {
    const date = new Date(purchase.createdAt);
    const year = date.getFullYear();
    const month = date.getMonth();
    if (year === 2023) {
      monthlyTotalPurchases[month] += purchase.total_purchase_amount;
    }
  });

  // const monthlySalesData = monthlyTotalSales.map((sales, index) => {
  //   // const monthName = labels[index];
  //   return sales;
  // });
  // console.log(monthlySalesData);

  // const monthlyPurchaseData = monthlyTotalPurchases.map((purchases, index) => {
  //   // const monthName = labels[index];
  //   return purchases;
  // });
  const monthLabels = labels.slice(0, new Date().getMonth() + 1);
  const data = {
    labels,
    datasets: [
      {
        label: "Total Purchases",
        data: monthlyTotalPurchases,
        backgroundColor: "#0ea5e9",
      },
      {
        label: "Total Sales",
        data: monthlyTotalSales,
        backgroundColor: "#14b8a6",
      },
    ],
  };

  return <Bar options={options} data={data} />;
}

export default SalesPurchaseStates;
